import React from "react";

// Styles
import MorningNotesRowContainer from "./MorningMeetingRow.styles";

// React Router
import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faUser } from "@fortawesome/free-solid-svg-icons";
import { MorningMeeting } from "../../../../screens/Company/MorningMeetings/MorningMeetings.types";
import { toDateAndTimeSeconds } from "../../../../utils/general.utils";
import { useHistory } from "react-router-dom";

interface Props {
    data: MorningMeeting;
}

const MorningMeetingRow = ({ data }: Props) => {
    const history = useHistory();

    const onRowClick = () => {
        history.push(`/portfolio/morning-meetings/${data.id}`);
    };

    return (
        <MorningNotesRowContainer onClick={onRowClick}>
            <div className="info">
                <div className="name">
                    {data.title}
                    {data?.cancelled && " (Cancelled)"}
                </div>
                <div className={"details"}>
                    {data.created_by && (
                        <Tooltip title={<h2>CREATED BY</h2>}>
                            <div className={"detail"}>
                                <FontAwesomeIcon icon={faUser} fixedWidth />
                                <p className={"capitalize"}>
                                    {data.created_by}
                                </p>
                            </div>
                        </Tooltip>
                    )}
                    <Tooltip title={<h2>MEETING DATE</h2>}>
                        <div className={"detail"}>
                            <FontAwesomeIcon icon={faCalendar} fixedWidth />
                            <p className={"capitalize"}>
                                {toDateAndTimeSeconds(data.date)}
                            </p>
                        </div>
                    </Tooltip>
                </div>
            </div>
        </MorningNotesRowContainer>
    );
};
export default MorningMeetingRow;
